export function getQueryValue(value: string | string[] | null | undefined, defaultValue: string): string;

export function getQueryValue(value: string | string[] | null | undefined): string | undefined;

export function getQueryValue(value: string | string[] | null | undefined, defaultValue?: string): string | undefined {
  if (value) {
    if (typeof value === 'string') {
      return value;
    }
    if (value.length) {
      return value[0];
    }
  }

  return defaultValue;
}

export function getQueryValues(value: string | string[] | null | undefined): string[] {
  if (value) {
    if (typeof value === 'string') {
      return [value];
    }
    return value;
  }
  return [];
}

export function parseQueryValue<T>(
  value: string | string[] | null | undefined,
  parser: (value: string) => T,
  defaultValue: T
): T;

export function parseQueryValue<T>(
  value: string | string[] | null | undefined,
  parser: (value: string) => T
): T | undefined;

export function parseQueryValue<T>(
  value: string | string[] | null | undefined,
  parser: (value: string) => T,
  defaultValue?: T
): T | undefined {
  if (value) {
    if (typeof value === 'string') {
      return parser(value);
    }
    if (value.length) {
      return parser(value[0]);
    }
  }

  return defaultValue;
}

export function parseQueryValues<T>(value: string | string[] | null | undefined, parser: (value: string) => T): T[] {
  if (value) {
    if (typeof value === 'string') {
      return [parser(value)];
    }
    return value.map((item) => parser(item));
  }

  return [];
}

export function parseQueryBoolean(value: string | string[] | null | undefined, defaultValue: boolean = false): boolean {
  if (Array.isArray(value)) {
    value = value[0];
  }
  if (value === null || value === undefined) {
    return defaultValue;
  }

  value = value.toLowerCase();

  if (value === 'true') {
    return true;
  }

  return false;
}

export type QueryParams = Record<string, string | number | boolean>;

export function getQueryString<T extends QueryParams>(params?: T, prependQuestionMark = true) {
  if (params) {
    const searchParams = new URLSearchParams();
    for (const key in params) {
      if (Object.prototype.hasOwnProperty.call(params, key)) {
        const value = params[key];
        if (Array.isArray(value)) {
          value.forEach((element) => {
            if (element) {
              searchParams.append(key, element?.toString() || '');
            }
          });
        } else if (value) {
          searchParams.append(key, value?.toString() || '');
        }
      }
    }
    const result = searchParams.toString();
    if (result) {
      return prependQuestionMark ? `?${result}` : result;
    }
  }
  return '';
}
